import Vue from 'vue';
import axios from 'axios';
import './companyNameSetting';

import ElementUI from 'element-ui';

import wysiwyg from 'vue-wysiwyg';
import VueTour from 'vue-tour';
import VueTheMask from 'vue-the-mask';

import VueSlickCarousel from 'vue-slick-carousel';

import VueChatScroll from 'vue-chat-scroll';
import vueCustomScrollbar from 'vue-custom-scrollbar';

import vueHeadful from 'vue-headful';

import PortalVue from 'portal-vue';
import {checkUserPermissions, PermissionsTypes} from '@/utils/permissions';
import CurrencyMask from '@/directives/currencyMask';
import detectScrollbars from '@/utils/scrollbars';
import App from './App';
import router from './router';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import 'vue-wysiwyg/dist/vueWysiwyg.css';

import '@/assets/scss/main.scss';

import '@/services/locale';
import '@/services/filters';
import i18n from './i18n';
import PosthogPlugin from './plugins/posthog';

window.isDev = window.location.hostname.includes('dev.')
  || window.location.hostname.includes('amplifyapp.com')
  || window.location.hostname.includes('dev-')
  || window.location.hostname.includes('localhost');

require('vue-tour/dist/vue-tour.css');

Vue.use(VueTheMask);
Vue.use(VueChatScroll);
Vue.component('vueCustomScrollbar', vueCustomScrollbar);
Vue.component('VueSlickCarousel', VueSlickCarousel);
Vue.component('vue-headful', vueHeadful);
Vue.use(VueTour);
Vue.use(PortalVue);
Vue.use(PosthogPlugin);
Vue.directive('currency-mask', CurrencyMask);

// Raise Element popups (dialogs, selects, tooltips) above the app's BaseOverlay (z-index 10000)
// so they render on top of the custom side modals instead of behind them.
Vue.use(ElementUI, { zIndex: 11000 });
Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    table: true,
    code: true,
    link: true,
  },
});

const eventBus = new Vue(); // для тура
export default eventBus;

Vue.config.productionTip = false;

//  на $mobile.show завязана логика в лендингах
Vue.prototype.$mobile = {
  show: window.innerWidth < 992,
};

const checkMobile = function () {
  Vue.prototype.$mobile.show = window.innerWidth < 992;
};

window.addEventListener('resize', checkMobile);

if (localStorage.getItem('ins-token')) {
  axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('ins-token')}`;
}

window.WebsocketUrl = 'wss://ws.renova.world/connection/websocket';
// Hubspot meeting url
window.HubspotMeetingUrl = window.isDev ? 'https://meetings.hubspot.com/anastasia-kotlyarova' : 'https://meetings.hubspot.com/ileana8/demo-con-illeana';
/**
 * Determine API URL based on hostname
 * for dev and staging environments use dev.checkme.tech
 * for all other hosts
 * @returns string
 */
const getApiURL = () => {
  if (process.env.VUE_APP_API_URL) {
    return process.env.VUE_APP_API_URL;
  }
  // Will not use API_HOST anymore because multiple domains are used under one instance
  if (window.isDev) {
    return window.companyName === 'Renova'
      ? (`https://dev.api.renova.${window.location.origin.includes('international') ? 'international' : 'world'}/api`)
      : 'https://dev.checkme.tech/api';
    // return 'https://admin.renova.world/api';
  }
  return window.companyName === 'Renova'
    ? (`https://api.renova.${window.location.origin.includes('international') ? 'international' : 'world'}/api`)
    : `${window.location.origin}/api`;
};
axios.defaults.baseURL = getApiURL();

axios.interceptors.request.use((config) => {
  if (!config.headers['X-Locale']) {
    // eslint-disable-next-line no-param-reassign
    config.headers['X-Locale'] = i18n.locale;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && router.currentRoute.name !== 'login' && router.currentRoute.name !== 'hr-login') {
      store.dispatch('AUTH_LOGOUT').then(() => {
        router.push('/login').catch(() => {});
      });
    }
    return Promise.reject(error);
  },
);

detectScrollbars();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
export const getMainPage = () => {
  const {providerType} = store.getters;

  if (providerType === 'sales_hub') {
    return '/admin/dashboard';
  }
  const mainRouter = checkUserPermissions([PermissionsTypes.PLANS_VIEW], store.getters.permissions) ? '/admin/programs' : '/admin/dashboard';
  return window.innerWidth <= 688 ? '/admin/tickets' : mainRouter;
};
